// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__1bjj8","large":"styles_large__1DZOk"};